import { useState, useEffect } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d7233ruuimmp87kg1s9g';
const STORAGE_KEY = 'remesasve_popup_dismissed';

export default function EmailPopup() {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  useEffect(() => {
    const dismissed = sessionStorage.getItem(STORAGE_KEY);
    if (dismissed) return;
    const t = setTimeout(() => setVisible(true), 9000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus('loading');
    const body = new URLSearchParams();
    body.append('email', email.trim());
    body.append('source', 'popup-automatico');
    body.append('timestamp', new Date().toISOString());
    body.append('page', 'remesasve.com');
    try {
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setTimeout(() => dismiss(), 2500);
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={dismiss} />
      <div className="relative bg-white rounded-3xl w-full max-w-md overflow-hidden">
        <div className="h-1.5 w-full bg-gradient-to-r from-green-500 to-emerald-400" />
        <button
          onClick={dismiss}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 cursor-pointer transition-colors z-10"
        >
          <i className="ri-close-line text-lg" />
        </button>
        <div className="p-8">
          <div className="w-14 h-14 flex items-center justify-center bg-green-100 rounded-2xl mx-auto mb-5">
            <i className="ri-notification-3-line text-green-600 text-2xl" />
          </div>
          <h3 className="text-xl font-extrabold text-gray-900 text-center mb-2">
            Recibe la mejor tasa USD/VES todos los días
          </h3>
          <p className="text-gray-500 text-sm text-center mb-6 leading-relaxed">
            Te avisamos cuál es la forma más barata de enviar dinero a Venezuela. Gratis, sin spam.
          </p>

          {status === 'success' ? (
            <div className="text-center py-4">
              <div className="w-14 h-14 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-3">
                <i className="ri-check-line text-green-600 text-2xl" />
              </div>
              <p className="font-bold text-gray-900 mb-1">¡Listo!</p>
              <p className="text-gray-500 text-sm">Recibirás las mejores tasas directamente en tu correo.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} data-readdy-form className="flex flex-col gap-3">
              <input
                type="email"
                name="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tucorreo@ejemplo.com"
                className="w-full border-2 border-gray-200 focus:border-green-400 rounded-xl px-4 py-3.5 text-sm text-gray-900 outline-none transition-colors"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="w-full bg-green-600 hover:bg-green-500 text-white font-bold py-3.5 rounded-xl text-sm transition-all cursor-pointer whitespace-nowrap disabled:opacity-60 hover:scale-[1.02] active:scale-95"
              >
                {status === 'loading' ? (
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-loader-4-line animate-spin" />
                    Enviando...
                  </span>
                ) : (
                  'Recibir alertas — Gratis'
                )}
              </button>
              {status === 'error' && (
                <p className="text-red-500 text-xs text-center">Ocurrió un error. Por favor intenta de nuevo.</p>
              )}
              <p className="text-gray-400 text-xs text-center">Sin spam. Cancela cuando quieras.</p>
            </form>
          )}

          <div className="flex items-center justify-center gap-4 mt-4 pt-4 border-t border-gray-100">
            {[
              { icon: 'ri-lock-line', label: 'Seguro' },
              { icon: 'ri-spam-3-line', label: 'Sin spam' },
              { icon: 'ri-gift-line', label: '100% Gratis' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-1 text-gray-400 text-xs">
                <i className={item.icon} />
                {item.label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
